import { call, put } from 'redux-saga/effects';
import { arrayToEntityMap } from "lib/data";

import { sendTeachersDataRequest } from "state/fetchSagas";
import { fetchNoticesSucceeded } from "state/teachers/actions";

import Notice from "state/teachers/entities/Notice";

export default function* fetchNotices(action) {
    
  const response = yield call(sendTeachersDataRequest, "get_my_notices");
  
  const noticesByID = arrayToEntityMap(Notice.fromAppserverValueList, notice => notice.id, response.data);
  
  yield put(fetchNoticesSucceeded(noticesByID));
    
}



// WEBPACK FOOTER //
// ./src/state/teachers/sagas/fetchNotices.js